function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "ICON_GREY_CLOSE_svg__cls-1",
  d: "M43.95 0l4.95 4.95-19.5 19.5 19.5 19.5-4.95 4.95-19.5-19.5-19.5 19.5L0 43.95l19.5-19.5L0 4.95 4.95 0l19.5 19.5L43.95 0z"
});

function SvgIconGreyClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 48.9 48.9"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OC45IDQ4LjkiPjxkZWZzPjwvZGVmcz48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iNDMuOTUgMCA0OC45IDQuOTUgMjkuNCAyNC40NSA0OC45IDQzLjk1IDQzLjk1IDQ4LjkgMjQuNDUgMjkuNCA0Ljk1IDQ4LjkgMCA0My45NSAxOS41IDI0LjQ1IDAgNC45NSA0Ljk1IDAgMjQuNDUgMTkuNSA0My45NSAwIi8+PC9zdmc+";
export { SvgIconGreyClose as ReactComponent };